<template>
    <div>
        <div
            class="kgr-alert kgr-alert--error kgr-row"
        >
            {{ tErrorsHint }}
        </div>
        <kgr-club-member-errors
            v-if="errorType === 'ClubMember'"
            :errors="errors"
        />
        <kgr-club-dog-errors
            v-else-if="errorType === 'ClubDog'"
            :errors="errors"
        />
        <kgr-member-club-fee-errors
            v-else-if="errorType === 'MemberClubFee'"
            :errors="errors"
        />
    </div>
</template>

<script>
import ClubDogErrors from './ClubDogErrors.vue';
import ClubMemberErrors from './ClubMemberErrors.vue';
import MemberClubFeeErrors from './MemberClubFeeErrors.vue';

export default {
    components: {
        'kgr-club-member-errors': ClubMemberErrors,
        'kgr-club-dog-errors': ClubDogErrors,
        'kgr-member-club-fee-errors': MemberClubFeeErrors,
    },
    props: {
        errors: {
            type: Array,
            required: true,
        },
        isTestRun: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        errorType() {
            return this.errors[0].entityType;
        },
        tErrorsHint() {
            return this.$t('Lists.actions.errors.hint', { count: this.errors.length });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
